import { AHText, Box, ListItem, useLayoutContext } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { ProductSearchListItem_storeProductSearchHit$key } from "./__generated__/ProductSearchListItem_storeProductSearchHit.graphql";
import { Image } from "expo-image";
import { ProductListItemProduct } from "./ProductListItem";

export function ProductSearchListItem(props: {
  children?: React.ReactNode;
  isFirst?: boolean;
  isLast?: boolean;
  product: ProductSearchListItem_storeProductSearchHit$key;
  disabled?: boolean;
  disabledReason?: string;
  onPressProduct(product: ProductListItemProduct): void;
}) {
  const layout = useLayoutContext();
  const result = useFragment(
    graphql`
      fragment ProductSearchListItem_storeProductSearchHit on StoreProductSearchHit {
        id
        nameHighlights {
          isHighlighted
          text
        }
        product {
          id
          imageUrl
          partNumber
          name
        }
      }
    `,
    props.product
  );

  return (
    <ListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      disabled={props.disabled}
      right={
        <Box
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {result.product.imageUrl ? (
            <Image
              source={{ uri: result.product.imageUrl }}
              contentFit="contain"
              style={{
                height: layout.circle.medium,
                width: layout.circle.medium,
              }}
            />
          ) : null}
        </Box>
      }
      onPress={() => props.onPressProduct(result.product)}
    >
      {props.disabled && props.disabledReason ? (
        <AHText
          type="subtitle"
          color={props.disabled ? "text-washed" : "text-secondary"}
          spaceBottom="small"
        >
          {props.disabledReason}
        </AHText>
      ) : null}
      <AHText
        type="list-item-title"
        color={props.disabled ? "text-washed" : "text-primary"}
      >
        {result.nameHighlights?.map((highlight, index) =>
          highlight.isHighlighted ? (
            <AHText
              key={index + highlight.text + (highlight.isHighlighted ? 1 : 0)}
              type="list-item-title-selected"
              color={props.disabled ? "text-washed" : "text-primary"}
            >
              {highlight.text}
            </AHText>
          ) : (
            <AHText
              type="list-item-title"
              color={props.disabled ? "text-washed" : "text-primary"}
              key={index + highlight.text + (highlight.isHighlighted ? 1 : 0)}
            >
              {highlight.text}
            </AHText>
          )
        ) ?? result.product.name}
      </AHText>
      {result.product.partNumber !== null ? (
        <ListItem.SubTitle
          color={props.disabled ? "text-washed" : "text-secondary"}
        >
          {result.product.partNumber}
        </ListItem.SubTitle>
      ) : null}
      {props.children}
    </ListItem>
  );
}
